export const canPublish = record => !record.published

export const canUpdate = record => record.__v !== record.publishedVersion

export const canPublishOrUpdate = record =>
  canPublish(record) || canUpdate(record)



// WEBPACK FOOTER //
// ./src/resource/util.js